/* assets/int-delivery-estimate.js
   Moved verbatim out of snippets/delivery-estimate.liquid on 2026-09-10 to cut the PDP
   HTML payload. It was a 23,231 byte inline <script> block there, with ONE Liquid tag,
   {{ 'int_pdp.your_location' | t | json }}, now read from data-int-your-location on the
   [data-int-delivery] root that findRoot() already selects.
   The snippet loads this with a PLAIN <script src>, NOT defer, at the exact position the
   inline block held, so execution order against the geo and cart scripts is unchanged.
   REVERT: paste this body back between <script> tags at that marker and put the Liquid
   tag back in place of INT_YOUR_LOCATION. */
(function(){
  var _r = document.querySelector('[data-int-delivery]');
  var INT_YOUR_LOCATION = (_r && _r.getAttribute('data-int-your-location')) || '';

(function () {
  /* THE RATE TABLE IS NO LONGER WRITTEN HERE (2026-09-25, bundle free shipping
     phase 2). Every bar, tier rate and weight bound is written once, in
     snippets/int-shipping-thresholds.liquid, and printed into the
     #int-ship-cfg JSON island in <head>. This file reads that island directly
     rather than the window.__intShip* globals, because it is a plain blocking
     <script> in the PDP body and assets/int-shipping-thresholds.js is deferred,
     so those globals do not exist yet when this runs. The island does.
     Built lazily on first use, into the same shape the functions below always
     used: { apparel|framed: { ZONE: { currency, free (major units),
     tiers: [[lowerKg, upperKg, rate]] } } }. The upper bounds are now Shopify's
     own (0.599 kg, not 0.59), so a 595 g parcel is no longer quoted a tier up.
     Missing island = empty table = the rate line says "Tracked", never a number
     this file invented. */
  var INT_SHIPPING_RATES = null;
  var INT_SHIP_CFG = null;

  function intShipCfg() {
    if (INT_SHIP_CFG) return INT_SHIP_CFG;
    try {
      INT_SHIP_CFG = JSON.parse((document.getElementById('int-ship-cfg') || {}).textContent || '{}');
    } catch (e) { INT_SHIP_CFG = {}; }
    return INT_SHIP_CFG;
  }

  function intRates() {
    if (INT_SHIPPING_RATES) return INT_SHIPPING_RATES;
    var cfg = intShipCfg();
    var out = { apparel: {}, framed: {} };
    var src = { apparel: 'apparel', framed: 'wallart' };
    if (cfg.thresholds && cfg.tiers) {
      for (var prof in src) {
        var key = src[prof];
        var thr = cfg.thresholds[key] || {};
        var tt = cfg.tiers[key] || {};
        var maxG = tt.maxGrams || [];
        for (var cur in thr) {
          var zone = INT_CURRENCY_TO_ZONE[cur];
          var rates = tt[cur];
          if (!zone || !rates || rates.length !== maxG.length) continue;
          var tiers = [], lower = 0;
          for (var t = 0; t < maxG.length; t++) {
            tiers.push([lower, maxG[t] / 1000, rates[t] / 100]);
            lower = (maxG[t] + 1) / 1000;
          }
          out[prof][zone] = { currency: cur, free: thr[cur] / 100, tiers: tiers };
        }
      }
    }
    INT_SHIPPING_RATES = out;
    return out;
  }

  /* Rule 4 in the snippet: 2 or more pieces ship the apparel parcel free.
     Null when the island does not carry the rule. */
  function intBundleMinPieces() {
    var b = intShipCfg().bundle;
    return (b && typeof b.minPieces === 'number' && b.minPieces > 0) ? b.minPieces : null;
  }

  var INT_EU_COUNTRIES = ['AT','BE','BG','HR','CY','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PT','RO','SK','SI','ES'];

  var INT_COUNTRY_NAMES = {
    DK:'Denmark', NO:'Norway', SE:'Sweden', PL:'Poland', CH:'Switzerland', GB:'the UK', US:'the US',
    AT:'Austria', BE:'Belgium', BG:'Bulgaria', HR:'Croatia', CY:'Cyprus', EE:'Estonia',
    FI:'Finland', FR:'France', DE:'Germany', GR:'Greece', HU:'Hungary', IE:'Ireland',
    IT:'Italy', LV:'Latvia', LT:'Lithuania', LU:'Luxembourg', MT:'Malta', NL:'Netherlands',
    PT:'Portugal', RO:'Romania', SK:'Slovakia', SI:'Slovenia', ES:'Spain'
  };

  var INT_LOCALE_MAP = {
    DKK:'da-DK', EUR:'de-DE', NOK:'nb-NO', SEK:'sv-SE', PLN:'pl-PL', CHF:'de-CH', GBP:'en-GB', USD:'en-US'
  };

  /* Language-driven locale (decoupled from currency) for the ETA date + copy.
     Reads the shared resolver from int-cart-i18n.js, then falls back. */
  var INT_LANG_BCP47 = { en:'en-GB', da:'da-DK', de:'de-DE', es:'es-ES', fr:'fr-FR', it:'it-IT',
                         sv:'sv-SE', nb:'nb-NO', nl:'nl-NL' };

  function intGetLangShort() {
    try {
      if (typeof window.__intCartI18nGetLocale === 'function') {
        var l = window.__intCartI18nGetLocale();
        if (l) return String(l).slice(0, 2).toLowerCase();
      }
    } catch (e) {}
    var hl = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
    return hl || 'en';
  }

  function intI18nString(key, fallback) {
    try {
      var loc = intGetLangShort();
      var dict = window.__intCartI18n && window.__intCartI18n[loc] && window.__intCartI18n[loc].custom;
      if (dict && dict[key] != null) return dict[key];
    } catch (e) {}
    return fallback;
  }

  var INT_CURRENCY_TO_ZONE = {
    
DKK:'DK', EUR:'EU', NOK:'NO', SEK:'SE', PLN:'PL', CHF:'CH', GBP:'GB', USD:'US'
  };
  function getActiveCurrency() {
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        return String(Shopify.currency.active).toUpperCase();
      }
    } catch (e) {}
    try {
      var m = document.cookie.match(/(?:^|;\s*)cart_currency=([^;]+)/);
      if (m) return decodeURIComponent(m[1]).toUpperCase();
    } catch (e) {}
    return null;
  }

  function getCachedCountry() {
    try {
      var cc = (window.Shopify && Shopify.country) || null;
      return cc ? String(cc).toUpperCase() : null;
    } catch (e) { return null; }
  }

  function getZone(country) {
    if (!country) return null;
    if (country === 'DK' || country === 'NO' || country === 'PL' ||
        country === 'SE' || country === 'CH' || country === 'GB' ||
        country === 'US') return country;
    if (INT_EU_COUNTRIES.indexOf(country) !== -1) return 'EU';
    return null;
  }

  /* Bands are tested on the UPPER bound only. Testing both bounds left holes
     between them — 0.591-0.599 kg, 1.591-1.599, 3.491-3.499 (framed:
     2.991-2.999, 6.991-6.999, 11.991-11.999) matched no band and fell through
     to the MOST EXPENSIVE one. Upper-bound-only rounds a between-bands weight
     UP to the next band, which is what Shopify charges anyway.
     ⚠️ Those holes also exist in Shopify's own rate conditions, where the
     consequence is worse: no rate is offered at all. Fix that in
     Settings → Shipping. This only stops the PDP misquoting. */
  function lookupTier(tiers, weightKg) {
    for (var i = 0; i < tiers.length; i++) {
      if (weightKg <= tiers[i][1]) return tiers[i][2];
    }
    return tiers[tiers.length - 1][2];
  }

  function calculateRate(profile, zone, weightKg, priceMajor) {
    var pd = intRates()[profile];
    if (!pd || !pd[zone]) return null;
    var z = pd[zone];
    if (priceMajor >= z.free) return { rate: 0, currency: z.currency, free: true };
    return { rate: lookupTier(z.tiers, weightKg), currency: z.currency, free: false };
  }

  function formatCurrency(amount, currency) {
    var locale = INT_LOCALE_MAP[currency] || 'en-US';
    try {
      var nf = new Intl.NumberFormat(locale, {
        style: 'currency', currency: currency,
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
      var parts = nf.formatToParts(amount);
      var symbol = '', number = '';
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === 'currency') symbol += parts[i].value;
        else if (parts[i].type !== 'literal') number += parts[i].value;
      }
      if (!symbol) return nf.format(amount);
      symbol = symbol.replace(/\.$/, '');
      return symbol + (symbol.length > 1 ? ' ' : '') + number;
    } catch (e) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  /* Walks forward plain CALENDAR days — weekends and holidays are already
     baked into the measured windows below, so nothing is skipped. */
  function addCalendarDays(date, days) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  /* Delivery window per DESTINATION COUNTRY, in CALENDAR days from the moment
     the order is placed — [earliest, latest].

     Source: 52 real delivered orders (Aug 2026, n=52), measured end to end as
     order-placed → carrier-delivered in calendar days. Production time,
     weekends and public holidays are therefore already included; do NOT add a
     separate production allowance on top and do NOT convert to business days.

     The upper bound is capped at 11 days by business decision, so a market
     whose measured tail ran longer still promises no more than 11 days.
     Any destination not listed here uses INT_DELIVERY_DEFAULT.

     US [4,8] is the exception: it is NOT measured. There are no delivered
     US orders yet. It is a provisional figure set 2026-08-09 on the basis
     of Gelato domestic fulfilment, production included, and should be
     replaced with a measured window once real US orders have landed.
     KEEP IN SYNC with the Ready Callback. */
  var INT_DELIVERY_DAYS = { GB:[5,8], IT:[6,10], FR:[8,11], DE:[8,11], DK:[9,11], ES:[9,11], US:[4,8] };
  var INT_DELIVERY_DEFAULT = [9,11];

  /* Falls back to the default window whenever the destination country cannot
     be resolved or is not one of the measured markets. */
  function getDeliveryDays(country) {
    if (!country) return INT_DELIVERY_DEFAULT;
    return INT_DELIVERY_DAYS[String(country).toUpperCase()] || INT_DELIVERY_DEFAULT;
  }

  /* Returns both ends of the delivery window plus display strings:
       { earliest, latest, latestText, rangeText }
     Same month  -> "18–24 Aug" (en dash, month printed once)
     Different   -> "29 Aug – 3 Sep"
     Returns null if the dates cannot be computed/formatted. */
  function getDeliveryWindow(country) {
    try {
      var today = new Date();
      var win = getDeliveryDays(country);
      var earliest = addCalendarDays(today, win[0]);
      var latest = addCalendarDays(today, win[1]);

      /* Date locale follows the active LANGUAGE (not currency) so FR/ES/IT
         no longer show German months. */
      var dateLocale = INT_LANG_BCP47[intGetLangShort()] || 'en-GB';
      var fmt = new Intl.DateTimeFormat(dateLocale, { month: 'short', day: 'numeric' });

      var earliestText = fmt.format(earliest);
      var latestText = fmt.format(latest);
      var rangeText;

      if (earliest.getFullYear() === latest.getFullYear() &&
          earliest.getMonth() === latest.getMonth()) {
        /* Same month: print the month once. Read the pieces back out of the
           formatter so day/month order follows the locale ("18–24 Aug" for
           en-GB, "Aug 18–24" for en-US) instead of being hard-coded. */
        var parts = fmt.formatToParts(earliest);
        var monthText = '', earliestDay = '', dayIndex = -1, monthIndex = -1;
        for (var i = 0; i < parts.length; i++) {
          if (parts[i].type === 'month') { monthText = parts[i].value; monthIndex = i; }
          else if (parts[i].type === 'day') { earliestDay = parts[i].value; dayIndex = i; }
        }
        var latestParts = fmt.formatToParts(latest), latestDay = '';
        for (var j = 0; j < latestParts.length; j++) {
          if (latestParts[j].type === 'day') latestDay = latestParts[j].value;
        }
        if (!earliestDay) earliestDay = String(earliest.getDate());
        if (!latestDay) latestDay = String(latest.getDate());
        var days = earliestDay + '-' + latestDay;
        if (!monthText) rangeText = earliestText + ' to ' + latestText;
        else if (monthIndex > -1 && dayIndex > -1 && monthIndex < dayIndex) rangeText = monthText + ' ' + days;
        else rangeText = days + ' ' + monthText;
      } else {
        rangeText = earliestText + ' to ' + latestText;
      }

      return { earliest: earliest, latest: latest, latestText: latestText, rangeText: rangeText };
    } catch (e) { return null; }
  }

  /* 2026-10-16 (Nils): the PDP says "With you by <date> at the latest".
     Date = today plus the TOP of the window, the same date the cart drawer
     prints (snippets/int-cart-delivery.liquid). English: "27 Oct" (US "Oct 27"),
     Danish and German spell the month out: "27. oktober", "27. Oktober". */
  function getLatestText(country) {
    try {
      var win = getDeliveryDays(country);
      var latest = addCalendarDays(new Date(), win[1]);
      var lang = intGetLangShort();
      /* 2026-11-03 (Nils): weekday and full month, "Friday 14 November". Same shape as the bag
         (int_cart_drawer.eta_date with eta_days and eta_months). */
      var us = (lang === 'en' && String(country || '').toUpperCase() === 'US');
      var loc = us ? 'en-US' : (INT_LANG_BCP47[lang] || 'en-GB');
      var fmt = new Intl.DateTimeFormat(loc, { weekday: 'long', day: 'numeric', month: 'long' });
      var p = {};
      fmt.formatToParts(latest).forEach(function (x) { if (x.type !== 'literal') p[x.type] = x.value; });
      if (!p.weekday || !p.day || !p.month) return fmt.format(latest);
      if (us) return p.weekday + ', ' + p.month + ' ' + p.day;
      if (lang === 'en') return p.weekday + ' ' + p.day + ' ' + p.month;
      if (lang === 'da') return p.weekday + ' ' + p.day + '. ' + p.month;
      if (lang === 'de') return p.weekday + ', ' + p.day + '. ' + p.month;
      return fmt.format(latest);
    } catch (e) { return null; }
  }

  /* ----------------------------------------------------------------
     FREE-SHIPPING THRESHOLD (added 2026-08-09, REWRITTEN 2026-09-25)

     The rules live at the top of snippets/int-shipping-thresholds.liquid.
     In short, as they apply to this line:
       · each delivery profile has its OWN bar, and each bar is compared with
         the WHOLE cart total AFTER automatic discounts (net). Measured on the
         storefront 2026-08-19 and again 2026-09-24. draftOrderCalculate does
         not apply automatic discounts, so never use it to check this.
       · so a print in the cart does NOT raise the bar for a tee. The old
         logic here took the HIGHEST bar among the profiles in the cart; it
         now takes THIS product's own profile's bar.
       · NEW, rule 4: 2 or more pieces ship the apparel parcel free. On an
         apparel or accessory page the line is reached once the cart already
         holds a piece, because adding this one makes two. Pieces is the
         cart's item_count, every line, gift cards included (the checkout
         discount has no product scope, Nils accepted that 2026-09-24).
         Wall Art keeps its own bar; rule 4 never frees the framed parcel.

     Gift cards are skipped from the SUBTOTAL: requires_shipping is false,
     they are never rated. They DO count as a piece.

     The cart read is passive. window.__intCartCache is populated by the
     theme's cart interceptor and by the Rebuy Ready Callback; we only
     fetch /cart.js ourselves if that cache is cold, and we never block
     the first paint on it. The rate and ETA render immediately and the
     threshold line fills in when the cart resolves.
     ---------------------------------------------------------------- */
    /* { subtotal: cents (whole cart, NET of discounts), pieces: item count,
         profiles: { apparel: bool, framed: bool } } */
  var INT_CART_SHIPPING = null;

  function intProfileOf(item) {
    return (item.product_type === 'Framed print') ? 'framed' : 'apparel';
  }

    /* ONE subtotal across every shippable line, plus a note of which delivery
     profiles are represented so the caller can pick the highest threshold in
     play. final_line_price is the NET line total AFTER discounts — what
     Shopify actually rates the threshold against. See the note above. */
  function readCartShipping(cart) {
    var out = { subtotal: 0, pieces: 0, profiles: { apparel: false, framed: false } };
    if (!cart || !cart.items) return out;
    if (typeof cart.item_count === 'number') {
      out.pieces = cart.item_count;
    } else {
      for (var k = 0; k < cart.items.length; k++) out.pieces += (cart.items[k].quantity || 1);
    }
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.requires_shipping === false || item.gift_card === true) continue;
      var line = (item.final_line_price != null)
        ? item.final_line_price
        : ((item.line_price != null)
            ? item.line_price
            : ((item.price || 0) * (item.quantity || 1)));
      out.subtotal += line;
      out.profiles[intProfileOf(item)] = true;
    }
    return out;
  }

  function ensureCart(cb) {
    if (window.__intCartCache) {
      INT_CART_SHIPPING = readCartShipping(window.__intCartCache);
      cb();
      return;
    }
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.__intCartCache = cart;
        INT_CART_SHIPPING = readCartShipping(cart);
        cb();
      })
      .catch(function () { INT_CART_SHIPPING = { subtotal: 0, pieces: 0, profiles: { apparel: false, framed: false } }; cb(); });
  }

  function renderThreshold(root, profile, zone) {
    var row = root.querySelector('[data-int-threshold-row]');
    var el = root.querySelector('[data-int-threshold]');
    if (!row || !el) return;

    /* THIS product's own profile's bar (rule 3). A print elsewhere in the
       cart no longer raises the bar for an apparel piece. */
    var pd = intRates()[profile];
    var z = pd && pd[zone];
    if (!z) { row.hidden = true; return; }

    /* WHOLE cart subtotal, not this profile's slice. */
    var inCartCents = INT_CART_SHIPPING ? (INT_CART_SHIPPING.subtotal || 0) : 0;
    var reached = (inCartCents / 100) >= z.free;

    /* Rule 4: the apparel parcel ships free from 2 pieces. The cart's pieces
       plus the one this page adds. Only once the cart is actually known. */
    var minPieces = intBundleMinPieces();
    if (!reached && profile === 'apparel' && minPieces !== null && INT_CART_SHIPPING &&
        ((INT_CART_SHIPPING.pieces || 0) + 1) >= minPieces) {
      reached = true;
    }

    row.hidden = false;
    if (reached) {
      el.classList.add('int-is-reached');
      el.textContent = rootStr('data-int-free-reached', 'Free shipping achieved');
    } else {
      el.classList.remove('int-is-reached');
      el.textContent = rootStr('data-int-free-over', 'Free shipping over {amount}')
        .replace('{amount}', formatCurrency(z.free, z.currency));
    }

    /* The rate line above is priced for THIS product on its own, because
       that is the honest answer before anything is in the bag. Once the
       whole cart's subtotal has already cleared the threshold in play,
       that standalone figure is no longer what the shopper
       will pay — checkout will ship free. Leaving it alone produced a
       flat contradiction on screen: "Shipping kr 99,00" sitting directly
       above "Free shipping achieved". Verified live 9 Aug 2026 with
       2.558 kr of framed prints in the cart. So when the threshold is
       met, the rate line follows it down to Free. */
    var rateEl = root.querySelector('[data-int-rate]');
    if (rateEl && reached) {
      rateEl.classList.remove('int-is-loading');
      rateEl.textContent = rootStr('data-int-free', 'Free');
    }
  }

  function findRoot() {
    return document.querySelector('[data-int-delivery]');
  }

  /* 2026-10-16 (Nils): the words in this panel come from locale keys printed
     on the root by snippets/delivery-estimate.liquid, so /da and /de read
     their own language. English is only the last fallback. */
  function rootStr(attr, fallback) {
    var r = findRoot();
    var v = r && r.getAttribute(attr);
    return v || fallback;
  }

  /* The server already printed the country name in the visitor's language.
     Keep it when the country is the one the server rendered; only a
     different country (rare) gets a name from this file. */
  function setCountryName(root, countryEl, country, fallback) {
    if (!countryEl || !country) return;
    if (country === (root.getAttribute('data-int-country-code') || '').toUpperCase()) return;
    countryEl.textContent = INT_COUNTRY_NAMES[country] || fallback;
  }

  function getCurrentFramedVariant() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) {
      var vid = String(input.value);
      if (window.product && window.product.variants) {
        for (var i = 0; i < window.product.variants.length; i++) {
          if (String(window.product.variants[i].id) === vid) return window.product.variants[i];
        }
      }
      var slide = document.querySelector('[data-media-slide][data-variant-id="' + vid + '"]');
      if (slide && slide.dataset.variantGrams) {
        return {
          grams: parseInt(slide.dataset.variantGrams, 10) || 0,
          price: parseInt(slide.dataset.variantPrice, 10) || 0
        };
      }
    }
    return null;
  }

  function render(root) {
    if (!root) return;
    var rateEl = root.querySelector('[data-int-rate]');
    var etaEl = root.querySelector('[data-int-eta]');
    var countryEl = root.querySelector('[data-int-country]');
    if (!rateEl) return;

    var country = getCachedCountry();
    var currency = getActiveCurrency();
    var zone = currency ? (INT_CURRENCY_TO_ZONE[currency] || null) : null;
    var isFramed = root.getAttribute('data-int-is-framed') === 'true';
    var profile = isFramed ? 'framed' : 'apparel';

    var grams, priceCents;
    if (isFramed) {
      var v = getCurrentFramedVariant();
      if (v) {
        grams = v.grams || 0;
        priceCents = v.price || 0;
      } else {
        grams = parseInt(root.getAttribute('data-int-product-grams'), 10) || 0;
        priceCents = parseInt(root.getAttribute('data-int-product-price-cents'), 10) || 0;
      }
    } else {
      grams = parseInt(root.getAttribute('data-int-product-grams'), 10) || 0;
      priceCents = parseInt(root.getAttribute('data-int-product-price-cents'), 10) || 0;
    }

    if (!zone) {
      setCountryName(root, countryEl, country, INT_YOUR_LOCATION);
      rateEl.classList.add('int-is-loading');
      rateEl.textContent = rootStr('data-int-tracked', 'Tracked');
      var _tr = root.querySelector('[data-int-threshold-row]');
      if (_tr) _tr.hidden = true;
      return false;
    }

    setCountryName(root, countryEl, country, country);
    if (etaEl) {
      /* 2026-10-16 (Nils): one sentence, the latest date. The words are the
         locale key int_pdp.eta_by, printed on the root by
         snippets/delivery-estimate.liquid, so da and de read their own
         language (the old int-cart-i18n.js dictionary is no longer on the
         theme, which made every language read English here). If no date can
         be built, the server text (int_pdp.eta_default) stays as it is. */
      var _latest = getLatestText(country);
      if (_latest) {
        var _tpl = root.getAttribute('data-int-eta-by') || 'With you by {date} at the latest';
        etaEl.textContent = _tpl.replace('{date}', _latest);
      }
    }

    var weightKg = grams / 1000;
    var priceMajor = priceCents / 100;
    var result = calculateRate(profile, zone, weightKg, priceMajor);

    rateEl.classList.remove('int-is-loading');
    if (!result) {
      rateEl.textContent = rootStr('data-int-tracked', 'Tracked');
      return true;
    }

    if (result.free) {
      rateEl.textContent = rootStr('data-int-free', 'Free');
    } else {
      rateEl.textContent = formatCurrency(result.rate, result.currency);
    }

    /* Threshold line. Paint from whatever we already know, then refresh
       once the cart resolves — never block the rate on a network read. */
    renderThreshold(root, profile, zone);
    ensureCart(function () {
      var r = findRoot();
      if (r) renderThreshold(r, profile, zone);
    });
    return true;
  }

  function init() {
    var root = findRoot();
    if (!root) return;

    if (!render(root)) {
      var tries = 0;
      var geoPoll = setInterval(function () {
        tries++;
        var r = findRoot();
        if (!r || render(r) || tries >= 20) clearInterval(geoPoll);
      }, 250);
      document.addEventListener('geo:ready', function () {
        clearInterval(geoPoll);
        var r = findRoot();
        if (r) render(r);
      });
    }

    document.addEventListener('variant:change', function () {
      var r = findRoot();
      if (r && r.getAttribute('data-int-is-framed') === 'true') render(r);
    });

    document.addEventListener('currency:changed', function () {
      window.__intCartCache = null;
      INT_CART_SHIPPING = null;
      var r = findRoot();
      if (r) render(r);
    });

    /* Adding to cart from this very page can cross the threshold, so the
       line has to update live. Both the theme and Rebuy emit one of these. */
    ['theme:cart:change'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        window.__intCartCache = null;
        INT_CART_SHIPPING = null;
        var r = findRoot();
        if (r) render(r);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

})();
